// GovtSkills.js
import React from "react";
import styled from "styled-components";
import { FaUserGraduate, FaLaptopCode, FaClipboardCheck, FaChartLine, FaBuilding, FaCertificate } from "react-icons/fa";

const GovtSkills = () => {
  return (
    <Wrapper>
      {/* Hero Section */}
      <HeroSection>
        <HeroHeading>Government Skilling Program!</HeroHeading>
        <HeroSubHeading>
          Empowering the next generation through collaboration, our Government Skilling Program
          is dedicated to transforming lives and meeting industry needs by shaping a skilled
          workforce for the future.
        </HeroSubHeading>
      </HeroSection>

      {/* Introduction */}
      <IntroSection>
        <IntroHeading>Let Us Empower the Future Together!</IntroHeading>
        <IntroText>
          At Tally Education, we believe in the power of collaboration to drive meaningful change.
          With an extensive network across multiple cities and collaborations with esteemed colleges,
          government departments, and institutions, we are dedicated to skilling, upskilling, and
          reskilling the young generation. Our government collaborations are pivotal to these efforts,
          blending the strengths of the public and private sectors to create impactful skilling opportunities.
        </IntroText>
      </IntroSection>

      {/* Key Benefits */}
      <BenefitsSection>
        <BenefitCard>
          <FaUserGraduate size={40} color="#F7AD2B"/>
          <BenefitTitle>Enhanced Employability</BenefitTitle>
          <BenefitText>
            Empowering the youth with skill-based training enhances their employability, fostering a
            pathway to sustainable careers and economic independence.
          </BenefitText>
        </BenefitCard>
        <BenefitCard>
          <FaLaptopCode size={40} color="#F7AD2B"/>
          <BenefitTitle>Exclusive Learning Platform</BenefitTitle>
          <BenefitText>
            Offering a robust platform, Tally enables students to assess and enhance their proficiency
            in Computerised Accounting, Finance, and Business Administration.
          </BenefitText>
        </BenefitCard>
        <BenefitCard>
          <FaClipboardCheck size={40} color="#F7AD2B"/>
          <BenefitTitle>NEP Compliance</BenefitTitle>
          <BenefitText>
            Enabling students in NEP-implemented states to earn the required credits and be job-ready on graduation.
          </BenefitText>
        </BenefitCard>
        <BenefitCard>
          <FaChartLine size={40} color="#F7AD2B"/>
          <BenefitTitle>Economic Growth</BenefitTitle>
          <BenefitText>
            Targeted upskilling initiatives uplift various segments of society, fostering inclusive growth
            and reducing disparities for a more equitable future.
          </BenefitText>
        </BenefitCard>
      </BenefitsSection>

      {/* Government Partners */}
      <SectionHeading>Our Prestigious Government Partners</SectionHeading>
      <PartnersGrid>
        <PartnerCard>
          <FaBuilding size={30} color="#1E7A79"/>
          <PartnerTitle>Centre for Digital Imaging and Technology (C-DIT), Kerala</PartnerTitle>
          <PartnerText>
            Imparts education and training in communication, digital media, and IT space.
          </PartnerText>
        </PartnerCard>
        <PartnerCard>
          <FaBuilding size={30} color="#1E7A79"/>
          <PartnerTitle>Rajasthan Knowledge Corporation Limited (RKCL), Jaipur</PartnerTitle>
          <PartnerText>
            Works for e-Empowerment through digital literacy and comprehensive skill development.
          </PartnerText>
        </PartnerCard>
        <PartnerCard>
          <FaBuilding size={30} color="#1E7A79"/>
          <PartnerTitle>Kerala Academy of Skills Excellence (KASE), Kerala</PartnerTitle>
          <PartnerText>
            Facilitates state-wide skill development initiatives to elevate workforce skills globally.
          </PartnerText>
        </PartnerCard>
        <PartnerCard>
          <FaBuilding size={30} color="#1E7A79"/>
          <PartnerTitle>CSC SPV E-Governance Services India Limited, New Delhi</PartnerTitle>
          <PartnerText>
            Directs India’s youth toward becoming skilled resources and entrepreneurs.
          </PartnerText>
        </PartnerCard>
        <PartnerCard>
          <FaBuilding size={30} color="#1E7A79"/>
          <PartnerTitle>Additional Skill Acquisition Program (ASAP), Kerala</PartnerTitle>
          <PartnerText>
            Focuses on skilling students and the general community to enhance employability.
          </PartnerText>
        </PartnerCard>
      </PartnersGrid>

      {/* Collaborate With Us */}
      <SectionHeading>Collaborate With Us</SectionHeading>
      <CollaborateGrid>
        <CollaborateCard>
          <FaLaptopCode size={35} color="#F7AD2B"/>
          <CollaborateTitle>Digital Content</CollaborateTitle>
          <CollaborateText>
            Self-paced learning modules created primarily for skilling, upskilling, and reskilling.
          </CollaborateText>
        </CollaborateCard>
        <CollaborateCard>
          <FaUserGraduate size={35} color="#F7AD2B"/>
          <CollaborateTitle>Learning Support</CollaborateTitle>
          <CollaborateText>
            Real business scenario-based learning and training support through our empanelled partners.
          </CollaborateText>
        </CollaborateCard>
        <CollaborateCard>
          <FaCertificate size={35} color="#F7AD2B"/>
          <CollaborateTitle>Tally Calculus</CollaborateTitle>
          <CollaborateText>
            Assessment engine that facilitates online tests in all streams.
          </CollaborateText>
        </CollaborateCard>
        <CollaborateCard>
          <FaClipboardCheck size={35} color="#F7AD2B"/>
          <CollaborateTitle>Verifiable Certificate</CollaborateTitle>
          <CollaborateText>
            Issue co-branded verifiable certificates to Tally certified learners.
          </CollaborateText>
        </CollaborateCard>
        <CollaborateCard>
          <FaBuilding size={35} color="#F7AD2B"/>
          <CollaborateTitle>Tally Job Portal</CollaborateTitle>
          <CollaborateText>
            Facilitate the job searching and hiring process for the learners as well as recruiters.
          </CollaborateText>
        </CollaborateCard>
      </CollaborateGrid>
    </Wrapper>
  );
};

export default GovtSkills;

// ---------------- Styled Components ----------------
const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px 60px 20px; /* top padding to avoid header overlap */
  color: ${(props) => props.theme.colors.dark};
`;

const HeroSection = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;
const HeroHeading = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 20px;
`;
const HeroSubHeading = styled.p`
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.medium};
`;

const IntroSection = styled.div`
  max-width: 900px;
  margin: 0 auto 60px auto;
  text-align: center;
`;
const IntroHeading = styled.h2`
  font-size: 2rem;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 15px;
`;
const IntroText = styled.p`
  font-size: 1.1rem;
  color: #555;
`;

const BenefitsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 25px;
  margin-bottom: 60px;
`;
const BenefitCard = styled.div`
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;
const BenefitTitle = styled.h3`
  margin: 15px 0;
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.dark};
`;
const BenefitText = styled.p`
  font-size: 1rem;
  color: #555;
`;

const SectionHeading = styled.h2`
  text-align: center;
  font-size: 2rem;
  margin: 60px 0 40px;
  color: ${(props) => props.theme.colors.secondary};
`;

const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-bottom: 60px;
`;
const PartnerCard = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;
const PartnerTitle = styled.h3`
  margin: 12px 0 10px;
  font-size: 1.1rem;
  color: ${(props) => props.theme.colors.dark};
`;
const PartnerText = styled.p`
  font-size: 0.95rem;
  color: #555;
`;

const CollaborateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 25px;
  margin-bottom: 80px;
`;
const CollaborateCard = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;
const CollaborateTitle = styled.h3`
  font-size: 1.1rem;
  margin: 12px 0 8px;
  color: ${(props) => props.theme.colors.dark};
`;
const CollaborateText = styled.p`
  font-size: 0.95rem;
  color: #555;
`;
